import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth({ children }) {
  const { auth } = useAuth();

  if (!auth || !auth.token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
